export const routeName = 'ProductionCalendarPage'

export const route = {
  path: '/load-calendar/production-calendar',
  name: routeName,
  component: () => import('./ProductionCalendarPage.vue')
}
